// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.bat[data-v-4c925c9e] .sponsoring__container.webrivage-optin-client {\n  border: none;\n}\n.consent-preview[data-v-4c925c9e] {\n  padding: 12px;\n}\n.consent-preview__hint[data-v-4c925c9e] {\n  margin: 12px 0 0;\n  font-size: 12px;\n  color: rgba(0, 0, 0, 0.6);\n}\n", ""]);
// Exports
module.exports = exports;
